import { useSelector } from "react-redux";

export function Loader() {
  const showLoader = useSelector((state) => state.showLoader);
  return (
    showLoader && (
      <div className="fixed inset-0 z-[60] bg-gray-600/50">
        <div className="w-full h-full flex items-center justify-center">
          <span id="wrapper" className="block relative h-[80px] w-80px]">
            <span
              id="one"
              className="bg-gray-500 absolute h-[80px] w-[80px] rounded-full opacity-[0.6] top-0 left-0  animate-[loader_2.1s_ease-in-out_1s_infinite_normal_none_running]"
            ></span>
            <span
              id="two"
              className="bg-gray-400 absolute h-[80px] w-[80px] rounded-full opacity-[0.6] top-0 left-0  animate-[loader_2.1s_ease-in-out_0s_infinite_normal_none_running]"
            ></span>
          </span>
        </div>
      </div>
    )
  );
}
